<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ grocer.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CButton
                            v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)"  
                            color="primary" @click="addCategory">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" />
                                    </td>
                                    <td>{{ category.title }}</td>
                                    <td v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)" >
                                        <CButton @click="editCategory(category)">
                                            <CIcon :content="$options.icons.cilPencil" class="handle" />
                                        </CButton>
                                        <CButton @click="removeCategory(category)">
                                            <CIcon :content="$options.icons.cilTrash" class="handle" />
                                        </CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)" >
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save">Сохранить порядок</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <GrocerCategoryUpsertDialog
            ref="upsertDialog"
            :entity="selectedCategory"
            @success="fetch" />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';

    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import GrocerCategoryUpsertDialog from '@/components/grocers/GrocerCategoryUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'GrocerCategories',

        components: {
            GrocerTabLinks,
            draggable,
            GrocerCategoryUpsertDialog,
            AppConfirmDialog,
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },

        data() {
            return {
                grocer: {
                    title: '',
                },
                categories: [],
                selectedCategory: {},
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/grocers/' + id)
                    .then(resp => {
                        this.grocer = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get('/grocers/' + id + '/categories')
                    .then(resp => {
                        this.categories = resp.data.map(item => {
                            item.enabled = Boolean(item.enabled);
                            item.empty = Boolean(item.empty);
                            return item;
                        });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    categoriesToSave.push({
                        id: category.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/grocers/' + this.grocer.id + '/categories/reorder', {
                        reorder: categoriesToSave,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            addCategory() {
                this.selectedCategory = {
                    grocer_id: this.grocer.id,
                };
                this.$refs.upsertDialog.open();
            },

            editCategory(category) {
                this.selectedCategory = category;
                this.$refs.upsertDialog.open();
            },

            removeCategory(category) {
                this.selectedCategory = category;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedCategory.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(
                        `/grocers/${this.selectedCategory.grocer_id}/categories/${this.selectedCategory.id}`
                    )
                );

                if (error) {
                    return this.$root.$emit('showError', 'ошибка при удалении категории. ' + error);
                }

                await this.fetch();
            },

            goBack() {
                this.$router.push({ path: '/grocers/' + this.$route.params.id });
            },
        },
    };
</script>
<style scoped>
.handle {
    cursor: pointer;
}
</style>
